var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaycircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 19.9197 19.9218",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 19.9218,
    opacity: 0,
    width: 19.9197,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.95469 19.9094C15.4553 19.9094 19.9197 15.4553 19.9197 9.95469C19.9197 4.45408 15.4553 0 9.95469 0C4.46443 0 4.44089e-16 4.45408 4.44089e-16 9.95469C4.44089e-16 15.4553 4.46443 19.9094 9.95469 19.9094ZM9.95469 18.2559C5.36575 18.2559 1.66174 14.5436 1.66174 9.95469C1.66174 5.36575 5.36575 1.6535 9.95469 1.6535C14.5436 1.6535 18.2559 5.36575 18.2559 9.95469C18.2559 14.5436 14.5436 18.2559 9.95469 18.2559Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.13097 13.7698L13.6866 10.4819C14.1038 10.2514 14.0934 9.67462 13.6866 9.44419L8.13097 6.14988C7.71594 5.90086 7.1558 6.09391 7.1558 6.5628L7.1558 13.3569C7.1558 13.8258 7.67454 14.0499 8.13097 13.7698Z",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaycircle);
export default __webpack_public_path__ + "static/media/play.circle.4e89aaf7435172ba5c9861aeeabf1769.svg";
export { ForwardRef as ReactComponent };